import { useTranslation } from "@l2r-front/l2r-i18n"

import { I18N_NAMESPACE } from "../../../../common/constants/i18n"

import { RoadworksSidebarContent } from "../RoadworksSidebarContent"

import * as Styled from "./RoadworksSidebar.styled"

export function RoadworksSidebar() {

    const { t } = useTranslation([I18N_NAMESPACE])

    return (
        <Styled.SidebarContent
            id="works-sidebar"
            title={t(I18N_NAMESPACE, "containers.worksSidebar.title")}>
            <RoadworksSidebarContent />
        </Styled.SidebarContent>
    )
}
